/**
* jv.candidate.details.workflow.offerLetter.generation.controller Module
*
* Description
*/
angular.module('jv.candidate.details.workflow.offerLetter.generation.controller', [])
    .controller('jvCandidateDetailsWorkflowOfferLetterGenerationController', ['$scope', '$routeParams', 'candidates', '$location', '$rootScope', '$localStorage','jvHireUrlService', '$log',
        function($scope, $routeParams, candidates, $location, $rootScope, $localStorage, jvHireUrlService, $log){
            $scope.flags.loading = true;
            $scope.offerLetterTemplates = {};
            $scope.offerLetterTemplates.showGenerateOfferButton=false;
            $scope.offerLetterTemplates.showSigningOrder = false;
            $scope.offerLetterTemplates.selectedSigningOrder = null;
            $scope.fileProgress = {};
            $scope.localStorage = $localStorage;
            $scope.localStorage.offerLetters = $scope.localStorage.offerLetters || {};
            $scope.selectedOfferTemplate = {};
            $scope.selectedOfferTemplate.eSignatureProvider = null;
            $scope.selectedOfferTemplate.canGenerateOffer = true;
            $scope.isDocuSignIntegrationEnabled = false;

            var millisecs = 30000;
            var timer;
            var actionRoute = window.jvUrls.jhire + '/action/resource/';
            $scope.pdfFileURL = '';
            var startTimer = function(){
                var val = 0;
                
                var changeTime = function(val){
                    $('progress').attr('value', val);
                    $('progress .text_fallback').html(val+'%');
                };

                timer = window.setInterval( function(){
                    val += (100000 /millisecs);
                    changeTime(val);
                }, 1000);

                window.setTimeout(function(){
                    window.clearInterval(timer);
                }, millisecs);
            };

            var stopTimer = function(){
                window.clearInterval(timer);
            };

            candidates.getOfferLetterTemplates($routeParams.applicationId, $routeParams.stateId, function(res){
                $scope.flags.loading=false;
                if(res.offerSummary){
                    $scope.isDocuSignIntegrationEnabled = res.offerSummary.model.isDocuSignIntegrationEnabled;
                    $scope.offerLetterTemplates.showSigningOrder = res.offerSummary.model.showSigningOrder;
                    if($routeParams.stateId){
                        $scope.offerLetterTemplates.list = res.offerSummary.model.offerTemplates;
                        $scope.offerLetterTemplates.viewMode = false;
                    }else{
                        $scope.offerLetterTemplates.list = [];
                        $scope.offerLetterTemplates.viewMode = true;
                        $scope.offerLetterTemplates.offerKind = res.offerSummary.model.offerKind;
                        $scope.offerLetterTemplates.offerLetter = res.offerSummary.model.offerLetter;
                        $scope.offerLetterTemplates.docTemplate=  res.offerSummary.model.documentTemplate;
                        if($scope.offerLetterTemplates.offerKind === 'ESigGenerated' || $scope.offerLetterTemplates.offerKind === 'ESigUploaded'){
                            if($scope.offerLetterTemplates.docTemplate && $scope.localStorage.offerLetters[$scope.offerLetterTemplates.docTemplate.EId] && $scope.localStorage.offerLetters[$scope.offerLetterTemplates.docTemplate.EId].users){
                                $scope.offerLetterTemplates.selectedUsers = $scope.localStorage.offerLetters[$scope.offerLetterTemplates.docTemplate.EId].userObjs;
                                $scope.offerLetterTemplates.companySignerKey = $scope.offerLetterTemplates.docTemplate.EId;
                            } else if($scope.localStorage.offerLetters[$scope.offerLetterTemplates.offerLetter.EId] && $scope.localStorage.offerLetters[$scope.offerLetterTemplates.offerLetter.EId].users){
                                $scope.offerLetterTemplates.selectedUsers = $scope.localStorage.offerLetters[$scope.offerLetterTemplates.offerLetter.EId].userObjs;
                                $scope.offerLetterTemplates.companySignerKey = $scope.offerLetterTemplates.offerLetter.EId;
                            }
                        }
                        var params = {
                            applicationId: $routeParams.applicationId,
                            fId: angular.copy(res.offerSummary.model.offerLetter.EId)
                        };
                        var data= {
                            readMode: $rootScope.fastRead.uploadOffer ? 0 : 1
                        };
                        if(!angular.isUndefined(res.offerSummary.model.hasRupeeSymbol) && res.offerSummary.model.hasRupeeSymbol ){
                            data.hasRupeeSymbol = res.offerSummary.model.hasRupeeSymbol;
                        }

                        if($rootScope.fastRead.uploadOffer){
                            $rootScope.fastRead.uploadOffer = false;
                        }

                        $scope.file = {};
                        $scope.offerLetterTemplates.selectedFile = {};
                        $('progress').attr('value', 0);
                        startTimer();
                        candidates.viewOfferResource(params.applicationId, params.fId, $.param(data, true), function(){
                            stopTimer();
                            $scope.file = {
                                fId: res.offerSummary.model.offerLetter.EId,
                                name: res.offerSummary.model.offerLetter.fileName,
                                readMode: data.readMode ? 1 : 0
                            };

                            $scope.offerLetterTemplates.selectedFile={
                                fId: res.offerSummary.model.offerLetter.EId,
                                name: res.offerSummary.model.offerLetter.fileName
                            };
                            $scope.pdfFileURL = actionRoute + $scope.params.applicationId + '/offer/' + $scope.file.fId + '?readMode=' + $scope.file.readMode;
                            if(!angular.isUndefined(res.offerSummary.model.hasRupeeSymbol) && res.offerSummary.model.hasRupeeSymbol ){
                                $scope.pdfFileURL = $scope.pdfFileURL + '&hasRupeeSymbol=true';
                            }
                            $scope.pdfFileURL = $scope.pdfFileURL + '#zoom=100';
                        }, function(err){
                            $log.error(err);
                        });
                    }
                }
            });

            $scope.showGeneratedOfferLetter = function(readMode){
                $scope.flags.loading=true;
                var selectedTmpl = angular.fromJson($scope.offerLetterTemplates.selected);
                $('progress').attr('value', 0);
                $scope.offerLetterTemplates.selectedFile= {};
                $scope.file= {};
                candidates.generateOfferLetter($routeParams.applicationId, selectedTmpl.EId, function(res){
                    // Refresh local storage with last offer letter generated
                    let offerGenerated = $scope.localStorage.offerGenerated || {};
                    offerGenerated[$routeParams.applicationId] = selectedTmpl.EId;
                    $scope.localStorage.offerGenerated = offerGenerated;
                    if(res.msgInfo === 200){
                        $scope.selectedOfferTemplate.eSignatureProvider = res.offerSummary.model.eSignatureProvider;
                        $scope.selectedOfferTemplate.canGenerateOffer = res.offerSummary.model.canGenerateOffer;
                        if($scope.selectedOfferTemplate.canGenerateOffer){
                            $scope.flags.loading=false;
                            $scope.showMsg('OFFER_LETTER_GENERATED');
                            $scope.offerLetterTemplates.error = false;

                            $scope.selectCompanySigner($scope.offerLetterTemplates.selectedUsers);
                            var selectedOfferLetter = angular.fromJson($scope.offerLetterTemplates.selected);

                            if (angular.isDefined($scope.offerLetterTemplates.selectedSigningOrder)){
                             $scope.localStorage.offerLetters[selectedOfferLetter.EId].signingOrder = $scope.offerLetterTemplates.selectedSigningOrder;
                            }

                            var params = {
                                fId: (angular.isDefined(res.offerSummary.model) && res.offerSummary.model.offerLetter.EId) ? res.offerSummary.model.offerLetter.EId : '',
                                applicationId: $routeParams.applicationId
                            };
                            var data= {
                                readMode: 0
                            };
                            if(!angular.isUndefined(res.offerSummary.model.hasRupeeSymbol) && res.offerSummary.model.hasRupeeSymbol ){
                                data.hasRupeeSymbol = res.offerSummary.model.hasRupeeSymbol;
                            }

                            $scope.offerLetterTemplates.selectedFile = {
                                fId: (angular.isDefined(res.offerSummary.model) && res.offerSummary.model.offerLetter.EId) ? res.offerSummary.model.offerLetter.EId : '',
                                name: (angular.isDefined(res.offerSummary.model) && res.offerSummary.model.offerLetter.EId) ? res.offerSummary.model.offerLetter.fileName : ''
                            };
                            startTimer();

                            candidates.viewOfferResource(params.applicationId, params.fId, $.param(data, true), function(){
                                stopTimer();
                                if(angular.isDefined(res.offerSummary.model) && res.offerSummary.model.offerLetter){
                                    $scope.file = {
                                        fId: res.offerSummary.model.offerLetter.EId || '',
                                        name: res.offerSummary.model.offerLetter.fileName || ''
                                    };

                                    if(readMode){
                                        $scope.file.readMode = 0;
                                    }

                                    $scope.pdfFileURL = actionRoute + $scope.params.applicationId + '/offer/' + $scope.file.fId + '?readMode=' + $scope.file.readMode;
                                    if(!angular.isUndefined(res.offerSummary.model.hasRupeeSymbol) && res.offerSummary.model.hasRupeeSymbol ){
                                        $scope.pdfFileURL = $scope.pdfFileURL + '&hasRupeeSymbol=true';
                                    }
                                    $scope.pdfFileURL = $scope.pdfFileURL + '#zoom=100';
                                }
                            });

                            $scope.getApplicationDetails(true);
                        }else{
                            $scope.flags.loading=false;
                        }
                    }else
                    {
                        $scope.flags.loading=false;
                    }
                });
            };

            $scope.changeOfferLetter = function(){
                $scope.offerLetterTemplates.isESignTemplate = false;
                $scope.offerLetterTemplates.hasCompanySigner = false;
                $scope.offerLetterTemplates.showGenerateOfferButton = false;
                
                if(angular.isDefined($scope.offerLetterTemplates.selected) && $scope.offerLetterTemplates.selected.length > 0){
                    var offerLetter = angular.fromJson($scope.offerLetterTemplates.selected);
                    if(offerLetter && offerLetter.kind === 'eSignOfferLetter'){
                        $scope.flags.loading=true;
                        candidates.hasCompanySigner($routeParams.applicationId, offerLetter.EId, function(res){
                            $scope.flags.loading=false;
                            var _hasCompanySigner = res.msgInfo;
                            
                            if(angular.isDefined($scope.localStorage.offerLetters[offerLetter.EId])
                                    && (angular.isDefined($scope.localStorage.offerLetters[offerLetter.EId].users))
                                    && _hasCompanySigner){
                                $scope.offerLetterTemplates.selectedUsers = $scope.localStorage.offerLetters[offerLetter.EId].users;
                            }else{
                                delete $scope.offerLetterTemplates.selectedUsers;
                            }
                            
                            if($scope.offerLetterTemplates.selectedUsers){
                                if(angular.isArray($scope.offerLetterTemplates.selectedUsers) && $scope.offerLetterTemplates.selectedUsers.length > 0){
                                    $scope.offerLetterTemplates.showGenerateOfferButton = true;
                                }
                            }
                            
                            if(_hasCompanySigner){
                                $scope.offerLetterTemplates.hasCompanySigner = true;
                            }else{
                                $scope.offerLetterTemplates.showGenerateOfferButton = true;
                                delete $scope.localStorage.offerLetters[offerLetter.EId];
                            }
                            
                            $scope.offerLetterTemplates.isESignTemplate = true;
                        }, function(){
                            $scope.flags.loading=false;
                        });
                    }else{
                        $scope.offerLetterTemplates.showGenerateOfferButton = $scope.checkCompanySigner();
                    }
                }
            };

            $scope.selectCompanySigner = function(user){
                var selectedOfferLetter = angular.fromJson($scope.offerLetterTemplates.selected);
                $scope.localStorage.offerLetters[selectedOfferLetter.EId] = $scope.localStorage.offerLetters[selectedOfferLetter.EId] || {};
                $scope.localStorage.offerLetters[selectedOfferLetter.EId].users = [];
                $scope.localStorage.offerLetters[selectedOfferLetter.EId].userObjs = [];

                if(user){
                    $scope.localStorage.offerLetters[selectedOfferLetter.EId].users.push(user.EId);
                    $scope.localStorage.offerLetters[selectedOfferLetter.EId].userObjs.push(user);
                }
                
                $scope.offerLetterTemplates.showGenerateOfferButton = $scope.checkCompanySigner();
            };

            $scope.cancelGeneratedOffer = function(){
                candidates.removeGenOfferLetter($routeParams.applicationId, function(){
                    $scope.getWorkflowSummary(0);
                    jvHireUrlService.loadCandidateDetailsTab('workflow',$routeParams.applicationId);
                });
            };

            $scope.checkCompanySigner = function(){
                if(!$scope.offerLetterTemplates.selected){
                    return false;
                }
                if($scope.offerLetterTemplates.hasCompanySigner && !$scope.offerLetterTemplates.selectedUsers){
                    return false;
                }
                return true;
            };
            
            $scope.downloadFile = function(fastRead){
                if($scope.offerLetterTemplates.selectedFile.fId){
                    var data = {
                        applicationId: $routeParams.applicationId,
                        fId: $scope.offerLetterTemplates.selectedFile.fId,
                        fName: $scope.offerLetterTemplates.selectedFile.name,
                        readMode: fastRead ? 0 : 1
                    };
                    window.open('../../action/resource/' + data.applicationId + '/file/' + data.fId + '?readMode=' + data.readMode + '&kind=offer', '_blank');
                }
                else{
                    $scope.offerLetterTemplates.error = true;
                }
            };
    }]);